/* eslint-disable max-len */

import { useSelector } from "react-redux";
import { State } from "./util/store";


const translations: {[lang: string]: {[key: string]: string} } = {
    ru: {
        title: "Герои Меча и Магии III",
        legal: "О проекте",
        legal_text: "Игра основана на движке с открытым исходныи кодом VCMI[1]. Чтобы начать играть необходимо загрузить файлы с данными оригинальной игры HoMM3[2] в виде архива, файлов или каталога.",
        legal_text_short: "Игра основана на движке с открытым исходныи кодом VCMI.",
        data_source: "Файлы игры",
        data_archive: "Архив с файлами игры",
        data_archive_text: "Нажмите 'Выберите файл' и укажите архив который вы только что скачали. Архив должен содержать файлы игры в корневой папке.",
        data_db: "Ранее загруженные",
        next: "Продолжить",
        back: "Назад",
        loading_data_title: "Загрузка данных...",
        error: "Ошибка",
        open_browser_logs: "Откройте лог браузера для подробной информации...",
        start_the_game: "Запустить игру",
        loading_db: "Загрузка локальных данных...",
        config: "Конфигурация",
        resolution: "Разрешение",
        fit_screen: "Окно браузера",
        reset: "Сбросить конфигурацию",
        enter_url: "Введите адрес...",
        download_saves: "Скачать сохранения",
        upload_dlc: "Установить DLC (ZIP)",
        archive_link: "Ссылка на архив",
        instructions: "Инструкции",
        i1_download_zip: "1. Скачайте архив с файлами игры",
        i1_download_button: "Скачать",
        i2_extract_zip_to_folder: "2. Извлеките архив в каталог",
        i3_select_folder: "3. Выберите каталог с игрой используя кнопку ниже",
        about: "О программе",
        about_text: "Программа для запуска игры Heroes of Might and Magic III в браузере. Основана на открытом движке VCMI. Исходный код доступен на GitHub [1].",
        authors: "Авторы:",
        links: "Ссылки:",
        source_code: "Исходный код",
        support: "Поддержать проект",
        more: "Подробнее",
        browser_is_not_supported: "Браузер не поддерживается. Пожалуйста, используйте Chrome, Firefox, Edge или Safari",
        client: "Клиент",
        version: "Версия",
        data_provider: "Архив с файлами игры",
        language: "Язык",
        variant_is_not_supported: "Архив не поддерживается (не все файлы присутствуют)",
        not_an_archive: "Не архив",
        unpacking: "Распаковка",
        scanning: "Сканирование",
        loading: "Загрузка",
        dlc_error: "Ошибка загрузки DLC",
        all_files_found: "Все файлы уже загружены",
        not_all_files_found: "Для запуска игры загрузите указанные файлы:",
        clearing_files: "Очистка файлов...",
        clear: "очистить",
        upload_missing_files: "Загрузить файлы с устройства:",
        demo_hint: "Запустить DEMO игру, не требующую загрузки файлов игры",
        source_files_zip_hint: "Загрузить ZIP архив с файлами игры",
        source_files_dir_hint: "Указать каталог для загрузки файлов игры",
        auth: "Сохранения в облаке",
        key: "Ключ",
        get_key: "Получить ключ",
        hello: "Привет",
        cloud_saves: "Сохранения в облаке",
        available: "Доступны",
        not_available: "Недоступны",
        exit: "выйти",
        fix: "включить",
    },
    en: {
        title: "Heroes Of Might And Magic III",
        legal_text: "The game based on open-source engine VCMI[1]. To start playing, you need to upload data files of the original HoMM3 game[2] as an archive, files or catalog.",
        legal_text_short: "The game based on open-source engine VCMI.",
        data_source: "Game files",
        data_archive: "Archive with game files",
        data_archive_text: "Click 'Select file' and select the archive you just downloaded. The archive must contain the game files in the root folder.",
        data_db: "Already uploaded",
        next: "Next",
        back: "Back",
        loading_data_title: "Downloading data...",
        error: "Error",
        open_browser_logs: "Open browser log for more info...",
        start_the_game: "Start the game",
        loading_db: "Loading local files...",
        config: "Config",
        resolution: "Resolution",
        fit_screen: "Browser window",
        reset: "Reset config",
        enter_url: "Enter url...",
        download_saves: "Download saves",
        upload_dlc: "Install DLC (ZIP)",
        archive_link: "Link to game archive",
        instructions: "Instructions",
        i1_download_zip: "1. Download zip archive with game files",
        i1_download_button: "Download",
        i2_extract_zip_to_folder: "2. Extract zip archive to folder",
        i3_select_folder: "3. Select folder with game using button below",
        about: "About",
        about_text: "Program for running Heroes of Might and Magic III in browser. Based on open-source engine VCMI. Source code is available on GitHub [1].",
        authors: "Authors:",
        links: "Links:",
        source_code: "Source code",
        support: "Support",
        more: "Details",
        browser_is_not_supported: "Browser is not supported. Please use Chrome, Firefox, Edge or Safari",
        client: "Client",
        version: "Version",
        data_provider: "Archive with HoMM3 files",
        language: "Language",
        variant_is_not_supported: "Archive is not supported (not all files are present)",
        not_an_archive: "Not an archive",
        unpacking: "Unpacking",
        scanning: "Scanning",
        loading: "Loading",
        all_files_found: "All files already loaded",
        not_all_files_found: "For playing the game, please upload the following files:",
        upload_missing_files: "Upload files from device:",
        clear: "clear",
        clearing_files: "Clearing files...",
        demo_hint: "Launch DEMO game that does not require uploading game files",
        source_files_zip_hint: "Upload ZIP archive with game files",
        source_files_dir_hint: "Specify directory to upload game files",
        auth: "Cloud saves",
        key: "Key",
        get_key: "Get key",
        hello: "Hello",
        cloud_saves: "Cloud saves",
        available: "Available",
        not_available: "Not available",
        exit: "logout",
        fix: "enable",
    },
};

export function useT() {
    const lang = useSelector((state: State) => state.ui.lang);
    return (key: string) => {
        return (translations[lang] ?? translations.en)[key] ?? key;
    };
};
